import http from '@plugin/axios'

// 定性公式发布
export function publish(id: any) {
  return http({
    url: '/srmQualitativeFormula/release',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id }
  })
}

// 定性公式取消发布
export function unPublish(id: any) {
  return http({
    url: '/srmQualitativeFormula/unPublish',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id }
  })
}

// 获取供应商设置
export function getAllSuppClass(id: string | number = '') {
  return http({
    url: '/srmSuppClass/getAllSuppClass',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: {
      'id': id
    }
  })
}

// 查询穿梭框数据
export function getAllSupplierByFormula(classifyNo: string, formulaId?: string | number, purchaseUnitNo?: string | number) {
  return http({
    url: '/srmSupplierFormula/getAllSupplierByFormula',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      classifyNo,
      formulaId,
      purchaseUnitNo
    }
  })
}

// 总公式配置手动执行
export function srmGeneralManually(data: {id: string | number; statrtMonth: string; endMonth: string}) {
  return http({
    url: '/srmGeneralFormula/srmGeneralManually',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: data
  })
}
